<mat-paginator #matPaginator
            [(length)]="length"
            [showFirstLastButtons]="true"
            [hidePageSize]="false"
            [(pageSize)]="pageSize"
            [(pageIndex)]="pageIndex"
            [pageSizeOptions]="pageSizeOptions"
            (page)="getPaginatorData($event)">
</mat-paginator>
<div class="qtdeRegistros" *ngIf="length > 0 && !multiSelecao">{{length | number:"1.0-0":"BRL"}} Registro(s)</div>
